import { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./type";
import CleopatrasTreasureUtils from "./utils";

export const CleopatrasTreasureRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  const candyPayouts = Object.entries(payouts);
  const halfCandyCount = candyPayouts.length / 2;
  const payoutElement = [
    <tr key={2} className="text-center">
      {candyPayouts.slice(halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol" >
            {CleopatrasTreasureUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
    <tr key={1} className="text-center">
      {candyPayouts.slice(0, halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {CleopatrasTreasureUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
  ];
  const specialSymbols = [
    <tr key={1} className="text-center">
      {[4, 2, 3].map((symbol) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {CleopatrasTreasureUtils.convertSymbol(+symbol)}
          </div>
        </td>
      ))}
    </tr>,
  ];
  return (
    <>
      <h4 className="card-title">Game Rule</h4>
      <p className="card-text">
        Each symbol's winning combination payout are as according to the Paytable
        below.
      </p>
      <div className="card-text">
        <div className="row">
          {Object.entries(payouts).map(([symbol, payout], i) => (
            <div key={symbol} className="col-6 col-md-3 pb-3">
              <div className="row justify-content-center">
                <div className="symbol"  style={{width: "90px", height: "60px"}}>
                  {CleopatrasTreasureUtils.convertSymbol(+symbol)}
                </div>
              </div>
              <div className="row justify-content-center">{payout}</div>
            </div>
          ))}
        </div>
      </div>
      <p className="card-text">
        On every play, any combination of 4 or more of the same symbols
        aligned horizontally or vertically will result in a winning combination
      </p>
      <p className="card-text">
        After every matching symbol combinations, the gem symbols will blast off
        the map, allowing symbols above them to cascade down into a new play.
      </p>
      <p className="card-text">
        Additional winning combinations will be tallied in every round until no
        more winning combination can be tallied.
      </p>
      <h5 className="card-title">Bonus Features</h5>
      <h6 className="card-title">Multiplier Wheel</h6>
      <img src="/ct/roundwheel.png" alt="roundwheel" />
      <p className="card-text">
        In normal spin, each round of match increases the meter by 1 level.
      </p>
      <p className="card-text">
        At level 5 or above, the Multiplier Wheel is spun right before payout and the winnings will be multiplied by the resultant amount spun.  
      </p>
      <p className="card-text">
        Mini Multiplier Wheel  - 2x, 5x, 10x, 15x, 20x    
      </p>
      <p className="card-text">
        Minor Multiplier Wheel  - 30x, 32x, 35x, 38x, 40x, 50x    
      </p>
      <p className="card-text">
        Major Multiplier Wheel  - 60x, 62x, 65x, 68x, 70x, 80x    
      </p>
      <p className="card-text">
      Grand Multiplier Wheel  - 90x, 92x, 95x, 98x, 100x, 200x  
      </p>

      

      <br />

      <h6 className="card-title">Free Spin</h6>
      <div className="card-text">
        <div className="row">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={`scatter-${i}`} className="col-6 col-md-3 pb-3" >
              <div className="row justify-content-center">
                <div className="symbol" style={{width: "120px", height: "90px"}}>
                  {CleopatrasTreasureUtils.convertSymbol(25)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="card-text">
      In every round, there is a chance for scatter symbols to appear. Obtaining a miniumum of 3 scatter symbols on any spin grants free spins. 
      </p>
      <p className="card-text">
      During Free Spin mode, each round of match increases winnings by a multiplier that starts from 1x. 
      </p>
      <p className="card-text">
      There is also a chance of scatter symbols appearing during Free Spin mode to extend the number of free spins. 
      </p>
      <br />

      <h5 className="card-title">Buy Free Spins</h5>
      <p className="card-text">
        Free spin are played with 3 random symbols.
        <br />
        <img src="/ct/buyfreespins.png" alt="buyfreespins" />
      </p>
    </>
  );;
};
